import React, { useContext } from "react";

import useTags from "./useTags";

const TagsContext = React.createContext();

// Export custom hooks
export function useTagsContext() {
  return useContext(TagsContext);
}

// Providers
export function TagsProvider({ children }) {
  const {
    loading,
    teamTags,
    setTeamTags,
    loadTeamTags,
    addTag,
    addBulkTags,
    errors,
    isBulkEditModalVisible,
    setIsBulkEditModalVisible,
    updateData,
  } = useTags();

  return (
    <TagsContext.Provider
      value={{
        loading,
        teamTags,
        setTeamTags,
        loadTeamTags,
        addTag,
        addBulkTags,
        errors,
        isBulkEditModalVisible,
        setIsBulkEditModalVisible,
        updateData,
      }}
    >
      {children}
    </TagsContext.Provider>
  );
}
